import { ApiError } from './api.js';

/**
 * Sichtbarkeit des Dev-Logins auf der Anmeldeseite (reine Funktion, testbar).
 *
 * Der Server schaltet `/v1/auth/dev-users` mit **404 `dev_login_disabled`** ab, sobald
 * Azure-AD aktiv ist (`routes/auth.ts`). Vorher zeigte die Seite den Dev-Block trotzdem —
 * mit dem irreführenden Hinweis „API nicht erreichbar". Jetzt:
 * - `disabled`    → 404 vom Server: Dev-Block komplett ausblenden (Prod-Fall).
 * - `unreachable` → anderer Fehler (API wirklich down, Netz): Block zeigen + Hinweis.
 * - `available`   → Liste da (lokale Entwicklung).
 * - `loading`     → noch keine Antwort.
 */
export type DevLoginState = 'loading' | 'available' | 'disabled' | 'unreachable';

export function devLoginState(query: {
  isSuccess: boolean;
  isError: boolean;
  error: unknown;
}): DevLoginState {
  if (query.isSuccess) return 'available';
  if (!query.isError) return 'loading';
  if (query.error instanceof ApiError && query.error.status === 404) return 'disabled';
  return 'unreachable';
}
